import * as tslib_1 from "tslib";
/* tslint:disable */
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, createRouterPlugin } from '@souche-f2e/muji';
import Root, { router } from './Root';
import store from './store';
import bootstrap from '../bootstrap';
const init = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
    store.use(createRouterPlugin(router));
    store.init();
    if (typeof bootstrap === 'function') {
        yield bootstrap();
    }
    router.init();
});
const App = () => (<Provider store={store}>
    <Root />
  </Provider>);
const render = () => {
    ReactDOM.render(<App />, document.getElementById('root'));
};
init()
    .then(() => {
    render();
})
    .catch((err) => {
    if (process.env.NODE_ENV === 'development') {
        console.error(err);
    }
});
